<template>
  <div class="terminal-command-block">
    <terminal-command
      @command-complete="completeBlock"
      :username="username"
      :promptIcon="promptIcon"
      :command="command.command"
      :typeCharDelay="typeCharDelay"
    ></terminal-command>
    <terminal-result v-show="showResult" :result="command.result"></terminal-result>
  </div>
</template>

<script>
import TerminalCommand from "./TerminalCommand";
import TerminalResult from "./TerminalResult";
export default {
  components: { TerminalCommand, TerminalResult },
  props: ["promptIcon", "command", "username", "typeCharDelay"],
  data() {
    return {
      showResult: false,
      resultDelay: this.command.resultDelay || 1000
    };
  },
  methods: {
    completeBlock() {
      setTimeout(() => {
        this.showResult = true;
        this.$emit("block-complete");
      }, this.resultDelay);
    }
  }
};
</script>
